import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Fix for invalid locale tags in containerized environments (e.g. en-US@posix)
const _tls = Date.prototype.toLocaleString;
const _tlds = Date.prototype.toLocaleDateString;
const _tlts = Date.prototype.toLocaleTimeString;
Date.prototype.toLocaleString = function (...a) {
  try { return _tls.apply(this, a); } catch { return _tls.call(this, "en-US", a[1]); }
};
Date.prototype.toLocaleDateString = function (...a) {
  try { return _tlds.apply(this, a); } catch { return _tlds.call(this, "en-US", a[1]); }
};
Date.prototype.toLocaleTimeString = function (...a) {
  try { return _tlts.apply(this, a); } catch { return _tlts.call(this, "en-US", a[1]); }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
